import React from 'react'

export default function TitleComponent ( { title, para } ) {
    return (
        <div className="title-container">
            <div className="title">
                {title}
            </div>

            <div className="para">
                {para}
            </div>
        </div>
    )
}
